import { Autocomplete, TextField } from "@mui/material"

export default function SeletorIndicadorAgrupado({ change, indicadoresPossiveis }) {
    return (
        <Autocomplete
            multiple
            name="tiposIndicador"
            onChange={(event, value) => { change('tiposIndicador', value) }}
            options={indicadoresPossiveis}
            groupBy={(option) => option.type.fullName}
            getOptionLabel={(option) => option.constructor.abbrev + ' - ' + option.type.fullName} // valor após ser selecionado
            isOptionEqualToValue={(option, value) => option.constructor.abbrev === value.constructor.abbrev && option.type.abbrev === value.type.abbrev}
            sx={{ flex: 1 }}
            renderInput={(params) => <TextField {...params} label="Indicador" variant="standard" />}
            renderOption={(props, option) => <li {...props}>{option.constructor.fullName}</li>} // rótulo antes de ser selecionado
        />
    )
}